export default __webpack_public_path__ + "static/media/W_Wirapaga.80e013b8.svg";